import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgFuriousSelectedEmoji(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6 24.24c0-8.84 7.16-16 16-16s16 7.16 16 16-7.16 16-16 16-16-7.16-16-16Zm7.69 2.96c0 .65.53 1.18 1.18 1.18.66 0 1.18-.53 1.18-1.18 0-.65-.53-1.18-1.18-1.18-.65 0-1.18.53-1.18 1.18Zm-.79-3.65 3.55 2.21.66-1.06-3.55-2.21-.66 1.06Zm11.87 11.2c.8.15 1.52-.13 1.89-.73.37-.59.3-1.35-.17-1.99-.38-.49-1.82-2.08-4.47-2.08-2.5 0-3.95 1.45-4.46 2.07-.51.62-.58 1.42-.19 2.04.3.49.82.75 1.39.75.17 0 .33-.02.5-.06.55-.12 1.58-.25 2.66-.25h.02c1.16 0 2.35.15 2.83.25Zm3.41-7.55c0 .65.53 1.18 1.18 1.18.65 0 1.18-.53 1.18-1.18 0-.65-.53-1.18-1.18-1.18-.65 0-1.18.53-1.18 1.18Zm-1.26-2.5.66 1.06 3.55-2.21-.66-1.06-3.55 2.21Zm-8.4 8.13c.4-.48 1.53-1.61 3.49-1.61 2.08 0 3.19 1.22 3.49 1.59.16.2.2.42.11.56-.09.15-.31.2-.59.15-.55-.11-1.81-.27-3.07-.27-1.17.03-2.32.15-2.97.28-.26.07-.46.02-.56-.13-.08-.12-.09-.34.1-.57Z",
    fill: "currentColor"
  }));
}

export { SvgFuriousSelectedEmoji as default };
